import { ArrowUpRight } from "lucide-react";

const MarketCard = ({ market }) => {
  return (
    <article
      data-testid={`market-card-${market.code}`}
      className="group bg-white border border-brand-green/15 p-7 md:p-9 transition-all duration-300 hover:border-brand-gold hover:shadow-[0_18px_40px_-15px_rgba(0,109,119,0.25)]"
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <span className="text-3xl" aria-hidden>{market.flag}</span>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-widest text-brand-black/50">Market · {market.code}</p>
            <h3 className="font-display text-2xl text-brand-black mt-0.5">{market.name}</h3>
          </div>
        </div>
        <span className="font-mono text-[10px] uppercase tracking-widest px-2 py-1 bg-brand-green/5 text-brand-green border border-brand-green/20">
          Tariff · {market.tariff}
        </span>
      </div>

      <p className="text-sm mt-5 text-brand-black/75 leading-relaxed">{market.headline}</p>

      <div className="mt-6 pt-6 border-t border-brand-green/10 grid grid-cols-2 gap-4">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-widest text-brand-black/45">Market size</p>
          <p className="font-display text-2xl text-brand-teal mt-1">{market.size}</p>
          <p className="text-[11px] text-brand-black/50 mt-0.5">{market.sizeLabel}</p>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-widest text-brand-black/45">Certifications</p>
          <p className="text-xs text-brand-black/80 mt-1 leading-relaxed">{market.certs.join(" · ")}</p>
        </div>
      </div>

      <div className="mt-5">
        <p className="font-mono text-[10px] uppercase tracking-widest text-brand-black/45">Buyer profile</p>
        <p className="text-xs text-brand-black/70 mt-1.5 leading-relaxed">{market.buyers}</p>
      </div>

      <div className="mt-6 inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] text-brand-green group-hover:text-brand-gold transition">
        View details <ArrowUpRight size={14} />
      </div>
    </article>
  );
};

export default MarketCard;
